module.exports = __webpack_public_path__ + "img/product_51.a0bc6ca.webp";